import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import {
  GetJobPosts,
  ChangeJobPostStatus,
  GetJobRoles,
  GetListOfVendorsByEmployeeID,
  GenerateContent,
  defaultguid,
} from "../apiconstants/constants";
import parse from "html-react-parser";
import DOMPurify from "dompurify";
import Swal from "sweetalert2";
import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import { useCountry } from "../contexts/countrycodecontext.js";
import { Controller, useForm } from "react-hook-form";
import WYSIWYGEditor from "../helpers/WYSIWYGEditor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ListOfJobPosts = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    register,
    watch,
  } = useForm();

  const [searchType, setSearchType] = useState("skills");
  const [isLoading, setIsLoading] = useState(false);
  const [jobPosts, setJobPosts] = useState([]);
  const [filteredJobPosts, setFilteredJobPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(25);
  const [jobTypeInput, setJobTypeInput] = useState("");
  const [statusFilter, setStatusFilter] = useState("Active");
  const [jobRoles, setJobRoles] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [showIcon, setShowIcon] = useState("list");
  const [viewType, setViewType] = useState("list"); // 'grid' or 'list'
  const [showLinkedinModal, setShowLinkedinModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);
  const [experience, setexperience] = useState(null);
  const [jobDetails, setJobDetails] = useState({});
  const { selectedCountry } = useCountry();

  const [showMailModal, setShowMailModal] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({
    sendJobDetails: true,
    sendRTR: false,
    sendCandidateMail: false,
  });

  const [selectAll, setSelectAll] = useState(false);
  const [selectedJobPostIDs, setSelectedJobPostIDs] = useState([]);

  const navigate = useNavigate();
  const token = localStorage.getItem("jwtToken");

  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const email = localStorage.getItem("email");
  const roleID = localStorage.getItem("roleID");

  let Guid = "";
  if (roleID == 3) {
    Guid = employerGuid;
  } else {
    Guid = guid;
  }

  const dateFilterOptions = [
    { value: "", label: "Select Date Filter" },
    { value: "Past 7 days", label: "Past 7 days" },
    { value: "Past 30 days", label: "Past 30 days" },
    { value: "This month", label: "This month" },
    { value: "Past 6 months", label: "Past 6 months" },
    { value: "Past 1 year", label: "Past 1 year" }, // Default case
  ];

  // ------------------ Helpers ------------------

  function strip_html_tags(str) {
    if (str === null || str === "undefined" || str === undefined) return "";
    str = str.toString();
    str = str.replace(/<[^>]*>/g, "");
    return substring_str(str.replace("&nbsp;", "").replace(".&nbsp;", ""));
  }

  function substring_str(str) {
    if (str === null || str === " " || str === undefined) return "";
    str = str.toString();
    return str.substring(0, 50) + "...";
  }

  const handleViewToggle = (type) => {
    setViewType(type);
    setShowIcon(type);
  };

  const handleNavigate = (jobPostID) => {
    navigate(
      "/Employer/ListOfJobPosts/ViewAppliedCandidatesforJob?jobpost=" + jobPostID
    );
  };

  // ------------------ API Calls ------------------

  const fetchVendorsList = async (jobPostsData) => {
    setIsLoading(true);
    const GetapiUrl =
      GetListOfVendorsByEmployeeID.APIURL +
      `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

    try {
      const result = await Axios.get(GetapiUrl);
      setIsLoading(false);
      setClientData(result.data);

      // Match clientName with vendor email
      const updatedJobPosts = jobPostsData.map((job) => {
        const matchedVendor = result.data.find(
          (vendor) => job.clientName == vendor.vendorName
        );
        return {
          ...job,
          clientEmail: matchedVendor ? matchedVendor.vendorEmail : null,
        };
      });

      setJobPosts(updatedJobPosts);
    } catch (error) {
      console.log("Error fetching vendors: " + error);
      setIsLoading(false);
    }
  };

  const fetchJobPosts = async () => {
    if (!selectedCountry) return;
    setIsLoading(true);
    try {
      const response = await Axios.get(
        `${GetJobPosts.APIURL}?Userguid=${Guid}&CountryID=${selectedCountry}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setJobPosts(response.data);
      fetchVendorsList(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching job posts", error);
      setIsLoading(false);
    }
  };

  const fetchJobRoles = () => {
    if (!selectedCountry) return;
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
    Axios.get(getApiUrl)
      .then((response) => {
        setJobRoles(response.data);
      })
      .catch((error) => {
        console.error("Error fetching job roles:", error);
      });
  };

  // ------------------ Filters & Search ------------------

  const filterJobPosts = () => {
    let filtered = jobPosts;
    const lowerSearchTerm = jobTypeInput?.toLowerCase()?.trim();

    let searchTerms;
    let isAndSearch = false;

    if (
      lowerSearchTerm?.includes(" + ") ||
      lowerSearchTerm?.includes(" and ")
    ) {
      searchTerms = lowerSearchTerm.split(/\s*\+\s*|\s+and\s+/); // Split on "+" or "and"
      isAndSearch = true; // ALL terms must match (AND logic)
    } else if (lowerSearchTerm?.includes(" or ")) {
      searchTerms = lowerSearchTerm.split(/\s+or\s+/); // Split on "or"
      isAndSearch = false; // At least one term must match (OR logic)
    } else {
      searchTerms = [lowerSearchTerm]; // Single phrase
      isAndSearch = false;
    }

    searchTerms = searchTerms.map((term) => term.trim()); // Clean spaces

    const fieldMatchesTerm = (job, term) => {
      return [job.title, job.location, job.clientName].some((field) =>
        field?.toLowerCase()?.includes(term)
      );
    };

    // Apply AND / OR search logic
    filtered = filtered.filter((job) => {
      return isAndSearch
        ? searchTerms.every((term) => fieldMatchesTerm(job, term)) // ALL terms must match (AND)
        : searchTerms.some((term) => fieldMatchesTerm(job, term)); // At least one matches (OR)
    });

    // Status filter
    if (statusFilter === "Active") {
      filtered = filtered.filter((x) => x.status == "Active");
    } else if (statusFilter === "Closed") {
      filtered = filtered.filter((x) => x.status == "Closed");
    } else if (statusFilter === "On Hold") {
      filtered = filtered.filter((x) => x.status == "On Hold");
    }

    setFilteredJobPosts(filtered);
    setCurrentPage(0); // reset page on filter change
    setSelectAll(false);
    setSelectedJobPostIDs([]);
  };

  // ------------------ Selection & Email ------------------

  const handleSelectAll = () => {
    const isNowChecked = !selectAll;
    setSelectAll(isNowChecked);

    if (isNowChecked) {
      const activeIDs = filteredJobPosts.map((job) => job.jobPostID);
      setSelectedJobPostIDs(activeIDs);
    } else {
      setSelectedJobPostIDs([]);
    }
  };

  const handleCheckboxChange = (jobPostID) => {
    const alreadySelected = selectedJobPostIDs.includes(jobPostID);
    let updatedSelected = [];

    if (alreadySelected) {
      updatedSelected = selectedJobPostIDs.filter((id) => id !== jobPostID);
      setSelectAll(false);
    } else {
      updatedSelected = [...selectedJobPostIDs, jobPostID];

      const filteredIDs = filteredJobPosts.map((job) => job.jobPostID);
      if (updatedSelected.length === filteredIDs.length) {
        setSelectAll(true);
      }
    }

    setSelectedJobPostIDs(updatedSelected);
  };

  const handleMailRadioChange = (e) => {
    const { value } = e.target;

    setSelectedOptions({
      sendJobDetails: value === "sendJobDetails",
      sendRTR: value === "sendRTR",
      sendCandidateMail: value === "sendCandidateMail",
    });
  };

  const handleConfirm = () => {
    const selectedJobs = jobPosts
      .filter((job) => selectedJobPostIDs.includes(job.jobPostID))
      .map((job) => ({
        jobPostID: job.jobPostID,
        title: job.title,
        location: job.location,
        jobRole: job.jobRole,
        jobType: job.jobType,
        jobDescription: job.jobDescription,
        jobPositions: job.positions,
        payRate: job.payRate,
        endClient: job.endClient,
      }));

    localStorage.setItem("selectedJobPostDetails", JSON.stringify(selectedJobs));
    localStorage.setItem("emailOptions", JSON.stringify(selectedOptions));

    window.location.href = "/Employer/ShareJobDetailstoBenchSales";
  };

  // ------------------ Navigation Helpers ------------------

  const handleMatchedCandidates = ({
    jobDescription,
    jobRoleID,
    rolesAndResponsibilities,
    clientEmail,
    jobPostID,
    clientName,
    updatedDateFilter,
    jobType,
    location,
    title,
    endClient,
  }) => {
    localStorage.setItem("jobPostID", jobPostID);
    localStorage.setItem("updatedDateFilter", updatedDateFilter);
    localStorage.setItem("jobRoleID", jobRoleID);
    localStorage.setItem("jobDescription", jobDescription);
    localStorage.setItem("title", title);
    localStorage.setItem("jobType", jobType);
    localStorage.setItem("location", location);
    localStorage.setItem("endClient", endClient);

    navigate("/Employer/ViewMatchedInternalCandidates", {
      state: {
        jobDescription,
        jobRoleID,
        rolesAndResponsibilities,
        clientEmail,
        jobPostID,
        clientName,
        updatedDateFilter,
      },
    });
  };

  const handleMatchedLinkedinCandidates = ({
    jobDescription,
    location,
    experience,
    title,
    keyskills,
    jobType,
    jobRoleID,
    endClient,
    jobPostID,
  }) => {
    localStorage.setItem("didRunAnalyze", "false");

    navigate("/Employer/ViewMatchedLinkedinCandidates", {
      state: {
        jobDescription,
        location,
        experience,
        title,
        jobType,
        keyskills,
        fromJobPosts: true,
      },
    });
    localStorage.setItem("jobPostID", jobPostID);
    localStorage.setItem("jobDescription", jobDescription);
    localStorage.setItem("location", location);
    localStorage.setItem("experience", experience);
    localStorage.setItem("title", title);
    localStorage.setItem("jobType", jobType);
    localStorage.setItem("keyskills", keyskills);
    localStorage.setItem("jobRoleID", jobRoleID);
    localStorage.setItem("endClient", endClient);
  };

  // ------------------ Effects ------------------

  useEffect(() => {
    if (selectedCountry) {
      fetchJobPosts();
      fetchJobRoles();
    }
  }, [selectedCountry]);

  useEffect(() => {
    filterJobPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobPosts, jobTypeInput, statusFilter]);

  // ------------------ Pagination ------------------

  const handlePageClick = (e) => {
    setCurrentPage(e.selected);
  };

  const offset = currentPage * itemsPerPage;
  const currentItems = filteredJobPosts.slice(offset, offset + itemsPerPage);

  // ------------------ Handlers ------------------

  const handleJobTypeInputChange = (e) => {
    setJobTypeInput(e.target.value);
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
  };

  // ------------------ Render ------------------

  return (
    <ConsultantLayout>
      <div className="mt-4 pb-5">
        {/* Header row */}
        <div
          className="responsive-container"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h2 style={{ color: "#00a7ac" }}>List of Job Posts</h2>

          <div style={{ display: "flex", alignItems: "center" }}>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip>Evaluation Results</Tooltip>}
            >
              <button
                className="btn btn-primary mr-3"
                onClick={() => navigate("/Employer/OverallEvalutionResults")}
                style={{ backgroundColor: "#00a7ac" }}
              >
                <i
                  className="fas fa-tachometer-alt"
                  style={{ color: "#fff", cursor: "pointer" }}
                ></i>
              </button>
            </OverlayTrigger>

            {/* View toggle buttons */}
            {showIcon === "grid" && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>List View</Tooltip>}
              >
                <button
                  className="btn btn-primary"
                  onClick={() => handleViewToggle("list")}
                  style={{
                    backgroundColor: "#00a7ac",
                    height: "38px",
                    width: "38px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <i
                    className="fa fa-th-list"
                    style={{ color: "#fff", fontSize: "16px" }}
                  ></i>
                </button>
              </OverlayTrigger>
            )}

            {showIcon === "list" && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Grid View</Tooltip>}
              >
                <button
                  className="btn btn-primary"
                  onClick={() => handleViewToggle("grid")}
                  style={{
                    backgroundColor: "#00a7ac",
                    height: "38px",
                    width: "38px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <i
                    className="fa fa-th"
                    style={{ color: "#fff", fontSize: "16px" }}
                  ></i>
                </button>
              </OverlayTrigger>
            )}

            {/* Add Job Post */}
            <OverlayTrigger
              placement="bottom"
              overlay={(props) => (
                <Tooltip id="tooltip" {...props}>
                  Add Job Posts
                </Tooltip>
              )}
            >
              <Link to="/Employer/AddJobPosts">
                <button
                  className="btn btn-primary"
                  btn-type="button"
                  style={{ marginLeft: 20 }}
                >
                  <i className="fa fa-plus"></i>
                </button>
              </Link>
            </OverlayTrigger>
          </div>
        </div>

        {/* Filters row */}
        <div className="mt-3" style={{ display: "flex", gap: "10px" }}>
          <OverlayTrigger
            placement="bottom"
            overlay={(props) => (
              <Tooltip id="tooltip" {...props}>
                Search by Job Title or Client Name or Location
              </Tooltip>
            )}
          >
            <input
              type="text"
              className="form-control"
              placeholder="Search by Job Title or Client Name or Location"
              value={jobTypeInput}
              onChange={handleJobTypeInputChange}
              style={{ flex: "1" }}
            />
          </OverlayTrigger>

          <OverlayTrigger
            placement="bottom"
            overlay={(props) => (
              <Tooltip id="tooltip" {...props}>
                Search by Active / Closed Jobs
              </Tooltip>
            )}
          >
            <select
              className="form-control"
              value={statusFilter}
              onChange={handleStatusFilterChange}
              style={{ flex: "1", height: 50 }}
            >
              <option value="">Select All Jobs</option>
              <option value="Active">Active Jobs</option>
              <option value="Closed">Closed Jobs</option>
              <option value="On Hold">On Hold Jobs</option>
            </select>
          </OverlayTrigger>
        </div>

        <hr />

        {/* Select all + Send Email button */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "20px",
          }}
        >
          {statusFilter === "Active" && filteredJobPosts.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
                style={{ marginRight: "10px" }}
              />
              <span style={{ color: "#333" }}>Select All </span>
            </div>
          )}

          {selectedJobPostIDs.length > 0 && (
            <button
              className="btn btn-primary"
              style={{
                backgroundColor: "#00a7ac",
                height: 40,
                marginLeft: 10,
              }}
              onClick={() => {
                selectedJobPostIDs.length > 1
                  ? handleConfirm()
                  : setShowMailModal(true);
              }}
            >
              Send Email ({selectedJobPostIDs.length})
            </button>
          )}
        </div>

        {/* Main content */}
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <div>
            {viewType === "grid" ? (
              // ------------------ GRID VIEW ------------------
              <div className="row mt-5">
                {currentItems.map((jobPost) => (
                  <div
                    key={jobPost.jobPostID}
                    className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3"
                  >
                    <div
                      className="card"
                      style={{
                        background: "#f8f8f8",
                        border: "1px solid #00a7ac26",
                        borderRadius: 20,
                        height: 600,
                      }}
                    >
                      <div
                        className="card-header text-center"
                        style={{ background: "none", minHeight: 100 }}
                      >
                        <div className="row">
                          <div className="col-8">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <OverlayTrigger
                                placement="bottom"
                                overlay={(props) => (
                                  <Tooltip id="tooltip" {...props}>
                                    Job Title
                                  </Tooltip>
                                )}
                              >
                                <p
                                  className="card-title jb-head"
                                  style={{
                                    color: "#00a7ac",
                                    fontSize: 18,
                                    marginBottom: 0,
                                    cursor: "pointer",
                                  }}
                                >
                                  <b>{jobPost.title}</b>
                                </p>
                              </OverlayTrigger>

                              {(!jobPost.outreach_Type ||
                                jobPost.outreach_Type === "null" ||
                                jobPost.outreach_Type === "") && (
                                <i
                                  className="fa fa-exclamation-triangle"
                                  title="Action Required"
                                  style={{
                                    color: "#dc3545",
                                    fontSize: "14px",
                                    marginLeft: "6px",
                                    cursor: "pointer",
                                  }}
                                ></i>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-body" style={{ height: 400 }}>
                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="positions-tooltip" {...props}>
                              Job Role
                            </Tooltip>
                          )}
                        >
                          <p style={{ fontSize: 14 }}>
                            <i
                              style={{
                                fontSize: 14,
                                color: "#00a7ac",
                                marginRight: 10,
                              }}
                              className="fas fa-briefcase"
                              aria-hidden="true"
                            ></i>{" "}
                            {jobPost.jobRole}
                          </p>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="location-tooltip" {...props}>
                              Location - Job Type
                            </Tooltip>
                          )}
                        >
                          <p style={{ fontSize: 14 }}>
                            <i
                              style={{
                                fontSize: 14,
                                color: "#00a7ac",
                                marginRight: 10,
                              }}
                              className="fas fa-map-marker-alt"
                              aria-hidden="true"
                            ></i>
                            {jobPost.location}
                            {jobPost.jobType ? ` - ${jobPost.jobType}` : ""}
                          </p>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="clientname-tooltip" {...props}>
                              Client Name - Company Name
                            </Tooltip>
                          )}
                        >
                          <p style={{ fontSize: 14 }}>
                            <i
                              style={{
                                fontSize: 14,
                                color: "#00a7ac",
                                marginRight: 10,
                              }}
                              className="fas fa-user-tie"
                              aria-hidden="true"
                            ></i>
                            {jobPost.clientName}
                            {jobPost.vendorCompanyName
                              ? ` - ${jobPost.vendorCompanyName}`
                              : ""}
                          </p>
                        </OverlayTrigger>

                        {jobPost.endClient != null &&
                          jobPost.endClient !== "null" &&
                          jobPost.endClient !== "" && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={(props) => (
                                <Tooltip id="clientname-tooltip" {...props}>
                                  End Client Name
                                </Tooltip>
                              )}
                            >
                              <p style={{ fontSize: 14 }}>
                                <i
                                  style={{
                                    fontSize: 14,
                                    color: "#00a7ac",
                                    marginRight: 10,
                                  }}
                                  className="fas fa-user-tie"
                                  aria-hidden="true"
                                ></i>{" "}
                                {jobPost.endClient}
                              </p>
                            </OverlayTrigger>
                          )}

                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="billrate-tooltip" {...props}>
                              {selectedCountry == 1
                                ? "Expected CTC"
                                : "Bill Rate"}
                            </Tooltip>
                          )}
                        >
                          <p style={{ fontSize: 14 }}>
                            <i
                              style={{
                                fontSize: 14,
                                color: "#00a7ac",
                                marginRight: 10,
                              }}
                              className="fas fa-money-bill-wave"
                              aria-hidden="true"
                            ></i>{" "}
                            {jobPost.billRate}
                          </p>
                        </OverlayTrigger>

                        {jobPost.payRate != null &&
                          jobPost.payRate !== "null" &&
                          jobPost.payRate !== "" && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={(props) => (
                                <Tooltip id="billrate-tooltip" {...props}>
                                  {selectedCountry == 1
                                    ? " Current CTC"
                                    : "Pay Rate"}
                                </Tooltip>
                              )}
                            >
                              <p style={{ fontSize: 14 }}>
                                <i
                                  style={{
                                    fontSize: 14,
                                    color: "#00a7ac",
                                    marginRight: 10,
                                  }}
                                  className="fas fa-money-bill-wave"
                                  aria-hidden="true"
                                ></i>{" "}
                                {jobPost.payRate}
                              </p>
                            </OverlayTrigger>
                          )}

                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="jobdesc-tooltip" {...props}>
                              Job Description
                            </Tooltip>
                          )}
                        >
                          <p style={{ fontSize: 14 }}>
                            <i
                              style={{
                                fontSize: 14,
                                color: "#00a7ac",
                                marginRight: 10,
                              }}
                              className="fas fa-file-alt"
                              aria-hidden="true"
                            ></i>{" "}
                            {strip_html_tags(jobPost.jobDescription)}
                          </p>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="startdate-tooltip" {...props}>
                              Start Date
                            </Tooltip>
                          )}
                        >
                          <p style={{ fontSize: 14 }}>
                            <i
                              style={{
                                fontSize: 14,
                                color: "#00a7ac",
                                marginRight: 10,
                              }}
                              className="fas fa-calendar-alt"
                              aria-hidden="true"
                            ></i>{" "}
                            {jobPost.startDate
                              ? new Date(
                                  jobPost.startDate
                                ).toLocaleDateString()
                              : ""}
                          </p>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="enddate-tooltip" {...props}>
                              End Date
                            </Tooltip>
                          )}
                        >
                          <p style={{ fontSize: 14 }}>
                            <i
                              style={{
                                fontSize: 14,
                                color: "#00a7ac",
                                marginRight: 10,
                              }}
                              className="fas fa-calendar-alt"
                              aria-hidden="true"
                            ></i>{" "}
                            {jobPost.endDate
                              ? new Date(jobPost.endDate).toLocaleDateString()
                              : ""}
                          </p>
                        </OverlayTrigger>
                      </div>

                      <div className="card-footer d-flex justify-content-between">
                        <Link to={`/Employer/EditJobPosts?jobPost=${jobPost.jobPostID}`}>
                          <OverlayTrigger
                            placement="bottom"
                            overlay={(props) => (
                              <Tooltip id="tooltip" {...props}>
                                Edit
                              </Tooltip>
                            )}
                          >
                            <button
                              style={{ background: "none", border: "none" }}
                            >
                              <i
                                className="fa fa-edit mt-1"
                                aria-hidden="true"
                                style={{ fontSize: 20, color: "#00a7ac" }}
                              ></i>
                            </button>
                          </OverlayTrigger>
                        </Link>

                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="tooltip" {...props}>
                              View Matching Candidates
                            </Tooltip>
                          )}
                        >
                          <button
                            onClick={() => {
                              setShowModal(true);
                              setJobDetails({
                                jobDescription: jobPost.jobDescription,
                                jobRoleID: jobPost.jobRoleID,
                                 jobPostID: jobPost.jobPostID, 
                                rolesAndResponsibilities:
                                  jobPost.rolesAndResponsibilities,
                                clientEmail: jobPost.clientEmail,
                                jobPostID: jobPost.jobPostID,
                                clientName: jobPost.clientName,
                                location: jobPost.location,
                                title: jobPost.title,
                                jobType: jobPost.jobType,
                                endClient: jobPost.endClient,
                              });
                            }}
                            style={{ background: "none", border: "none" }}
                          >
                            <i
                              className="fa fa-list"
                              aria-hidden="true"
                              style={{ fontSize: 20, color: "#00a7ac" }}
                            ></i>
                          </button>
                        </OverlayTrigger>

                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="tooltip" {...props}>
                              Search from LinkedIn
                            </Tooltip>
                          )}
                        >
                          <button
                            onClick={() => {
                              setShowLinkedinModal(true);
                              setJobDetails({
                                jobDescription: jobPost.jobDescription,
                                 jobPostID: jobPost.jobPostID, 
                                title: jobPost.title,
                                jobType: jobPost.jobType,
                                keyskills: jobPost.keyskills,
                                jobRoleID: jobPost.jobRoleID,
                                endClient: jobPost.endClient,
                                location: jobPost.location,
                              });
                              setValue(
                                "jobDescription",
                                jobPost.jobDescription
                              );
                            }}
                            style={{ background: "none", border: "none" }}
                          >
                            <i
                              className="fa fa-search"
                              aria-hidden="true"
                              style={{ fontSize: 20, color: "#00a7ac" }}
                            ></i>
                          </button>
                        </OverlayTrigger>

                        <Link to={`/Employer/ViewJobPosts?jobPost=${jobPost.jobPostID}`}>
                          <OverlayTrigger
                            placement="bottom"
                            overlay={(props) => (
                              <Tooltip id="tooltip" {...props}>
                                View
                              </Tooltip>
                            )}
                          >
                            <button
                              style={{ background: "none", border: "none" }}
                            >
                              <i
                                className="fa fa-eye mt-1"
                                aria-hidden="true"
                                style={{ fontSize: 20, color: "#00a7ac" }}
                              ></i>
                            </button>
                          </OverlayTrigger>
                        </Link>

                        <Link
                          to={`/Employer/ViewEvaluationResults?jobPost=${jobPost.jobPostID}`}
                          state={{
                            jobTitle: jobPost.title,
                            clientName: jobPost.clientName,
                            companyName: jobPost.vendorCompanyName,
                          }}
                        >
                          <OverlayTrigger
                            placement="bottom"
                            overlay={(props) => (
                              <Tooltip id="tooltip" {...props}>
                                View Evaluation Results
                              </Tooltip>
                            )}
                          >
                            <button
                              style={{ background: "none", border: "none" }}
                            >
                              <i
                                className="fa fa-signal mt-1"
                                aria-hidden="true"
                                style={{ fontSize: 20, color: "#00a7ac" }}
                              ></i>
                            </button>
                          </OverlayTrigger>
                        </Link>

                        {statusFilter === "Active" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip">
                                Select to Send Email
                              </Tooltip>
                            }
                          >
                            <span>
                              <input
                                type="checkbox"
                                checked={selectedJobPostIDs.includes(
                                  jobPost.jobPostID
                                )}
                                onChange={() =>
                                  handleCheckboxChange(jobPost.jobPostID)
                                }
                                style={{
                                  width: 16,
                                  height: 16,
                                  cursor: "pointer",
                                  marginTop: "6px",
                                  marginLeft: "2px",
                                  accentColor: "#00a7ac",
                                  appearance: "auto",
                                }}
                              />
                            </span>
                          </OverlayTrigger>
                        )}

                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="tooltip" {...props}>
                              Search from Dice
                            </Tooltip>
                          )}
                        >
                          <div>
                            <Link
                              to="/Employer/DiceSearch"
                              state={{
                                jobDescription: jobPost.jobDescription,
                                title: jobPost.title,
                                location: jobPost.location,
                                jobPostID: jobPost.jobPostID,
                              }}
                              style={{ textDecoration: "none" }}
                            >
                              <button
                                type="button"
                                style={{
                                  marginTop: "6px",
                                  backgroundColor: "#00a7ac",
                                  border: "none",
                                  color: "#fff",
                                  fontWeight: "600",
                                  fontSize: "11px",
                                  width: "18px",
                                  height: "18px",
                                  borderRadius: "3px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  padding: 0,
                                  lineHeight: "1",
                                  transition: "background-color 0.2s ease",
                                }}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    "#008b8f")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.backgroundColor =
                                    "#00a7ac")
                                }
                              >
                                D
                              </button>
                            </Link>
                          </div>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              // ------------------ LIST VIEW ------------------
              <div
                className="col-12"
                style={{ overflowX: "auto", width: "100%" }}
              >
                <table
                  className="table"
                  style={{
                    minWidth: "100%",
                    fontSize: "12px",
                    wordWrap: "break-word",
                  }}
                >
                  <thead>
                    <tr>
                      <th>Job Title</th>
                      <th>Job Role</th>
                      <th>Location - Job Type</th>
                      <th style={{ minWidth: 100 }}>
                        Client Name - Company Name
                      </th>
                      <th>End Client Name</th>
                      <th>
                        {selectedCountry == 1 ? "Expected CTC" : "Bill Rate"}
                      </th>
                      <th>
                        {selectedCountry == 1 ? " Current CTC" : "Pay Rate"}
                      </th>
                      <th>Job Description</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th style={{ minWidth: 200 }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems?.map((jobPost) => (
                      <tr key={jobPost.jobPostID}>
                        <td
                          className="d-flex align-items-center"
                          style={{ borderBottomWidth: 0 }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <span>{jobPost.title}</span>

                            {(!jobPost.outreach_Type ||
                              jobPost.outreach_Type === "null" ||
                              jobPost.outreach_Type === "") && (
                              <i
                                className="fa fa-exclamation-triangle"
                                title="Action Required"
                                style={{
                                  color: "#dc3545",
                                  fontSize: "14px",
                                  marginLeft: "6px",
                                  cursor: "pointer",
                                }}
                              ></i>
                            )}

                            <OverlayTrigger
                              placement="bottom"
                              overlay={(props) => (
                                <Tooltip id="tooltip" {...props}>
                                  View Applied Candidates
                                </Tooltip>
                              )}
                            >
                              <FontAwesomeIcon
                                icon="fa-folder-open"
                                onClick={() =>
                                  handleNavigate(jobPost.jobPostID)
                                }
                                style={{
                                  marginLeft: 8,
                                  color: "#00a7ac",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                              />
                            </OverlayTrigger>
                          </div>
                        </td>

                        <td>{jobPost.jobRole}</td>
                        <td>
                          {jobPost.location}
                          {jobPost.jobType ? ` - ${jobPost.jobType}` : ""}
                        </td>
                        <td>
                          {jobPost.clientName}
                          {jobPost.vendorCompanyName
                            ? ` - ${jobPost.vendorCompanyName}`
                            : ""}
                        </td>
                        <td>{jobPost.endClient}</td>
                        <td>{jobPost.billRate}</td>
                        <td>{jobPost.payRate}</td>
                        <td>{strip_html_tags(jobPost.jobDescription)}</td>
                        <td>
                          {jobPost.startDate
                            ? new Date(
                                jobPost.startDate
                              ).toLocaleDateString()
                            : ""}
                        </td>
                        <td>
                          {jobPost.endDate
                            ? new Date(jobPost.endDate).toLocaleDateString()
                            : ""}
                        </td>

                        {/* Actions */}
                        <td
                          style={{
                            width: "180px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "nowrap",
                              gap: "4px",
                              alignItems: "center",
                              justifyContent: "center",
                              overflow: "hidden",
                            }}
                          >
                            {/* Edit */}
                            <Link
                              to={`/Employer/EditJobPosts?jobPost=${jobPost.jobPostID}`}
                            >
                              <OverlayTrigger
                                placement="bottom"
                                overlay={(props) => (
                                  <Tooltip id="tooltip" {...props}>
                                    Edit
                                  </Tooltip>
                                )}
                              >
                                <button
                                  style={{
                                    background: "none",
                                    border: "none",
                                  }}
                                >
                                  <i
                                    className="fa fa-edit mt-1"
                                    aria-hidden="true"
                                    style={{
                                      fontSize: 14,
                                      color: "#00a7ac",
                                    }}
                                  ></i>
                                </button>
                              </OverlayTrigger>
                            </Link>

                            {/* Matching Candidates */}
                            <OverlayTrigger
                              placement="bottom"
                              overlay={(props) => (
                                <Tooltip id="tooltip" {...props}>
                                  View Matching Candidates
                                </Tooltip>
                              )}
                            >
                              <button
                                onClick={() => {
                                  setShowModal(true);
                                  setJobDetails({
                                    jobDescription: jobPost.jobDescription,
                                    jobRoleID: jobPost.jobRoleID,
                                     jobPostID: jobPost.jobPostID, 
                                    rolesAndResponsibilities:
                                      jobPost.rolesAndResponsibilities,
                                    clientEmail: jobPost.clientEmail,
                                    jobPostID: jobPost.jobPostID,
                                    clientName: jobPost.clientName,
                                    location: jobPost.location,
                                    title: jobPost.title,
                                    jobType: jobPost.jobType,
                                    endClient: jobPost.endClient,
                                  });
                                }}
                                style={{
                                  background: "none",
                                  border: "none",
                                }}
                              >
                                <i
                                  className="fa fa-list"
                                  aria-hidden="true"
                                  style={{
                                    fontSize: 14,
                                    color: "#00a7ac",
                                  }}
                                ></i>
                              </button>
                            </OverlayTrigger>

                            {/* LinkedIn */}
                            <OverlayTrigger
                              placement="bottom"
                              overlay={(props) => (
                                <Tooltip id="tooltip" {...props}>
                                  Search from LinkedIn
                                </Tooltip>
                              )}
                            >
                              <button
                                onClick={() => {
                                  setShowLinkedinModal(true);
                                  setJobDetails({
                                    jobDescription: jobPost.jobDescription,
                                    title: jobPost.title,
                                     jobPostID: jobPost.jobPostID, 
                                    jobType: jobPost.jobType,
                                    keyskills: jobPost.keyskills,
                                    jobRoleID: jobPost.jobRoleID,
                                    endClient: jobPost.endClient,
                                    location: jobPost.location,
                                  });
                                  setValue(
                                    "jobDescription",
                                    jobPost.jobDescription
                                  );
                                }}
                                style={{
                                  background: "none",
                                  border: "none",
                                }}
                              >
                                <i
                                  className="fa fa-search"
                                  aria-hidden="true"
                                  style={{
                                    fontSize: 14,
                                    color: "#00a7ac",
                                  }}
                                ></i>
                              </button>
                            </OverlayTrigger>

                            {/* View */}
                            <Link
                              to={`/Employer/ViewJobPosts?jobPost=${jobPost.jobPostID}`}
                            >
                              <OverlayTrigger
                                placement="bottom"
                                overlay={(props) => (
                                  <Tooltip id="tooltip" {...props}>
                                    View
                                  </Tooltip>
                                )}
                              >
                                <button
                                  style={{
                                    background: "none",
                                    border: "none",
                                  }}
                                >
                                  <i
                                    className="fa fa-eye mt-1"
                                    aria-hidden="true"
                                    style={{
                                      fontSize: 14,
                                      color: "#00a7ac",
                                    }}
                                  ></i>
                                </button>
                              </OverlayTrigger>
                            </Link>

                            {/* Evaluation Results */}
                            <Link
                              to={`/Employer/ViewEvaluationResults?jobPost=${jobPost.jobPostID}`}
                              state={{
                                jobTitle: jobPost.title,
                                clientName: jobPost.clientName,
                                companyName: jobPost.vendorCompanyName,
                              }}
                            >
                              <OverlayTrigger
                                placement="bottom"
                                overlay={(props) => (
                                  <Tooltip id="tooltip" {...props}>
                                    View Evaluation Results
                                  </Tooltip>
                                )}
                              >
                                <button
                                  style={{
                                    background: "none",
                                    border: "none",
                                  }}
                                >
                                  <i
                                    className="fa fa-signal mt-1"
                                    aria-hidden="true"
                                    style={{
                                      fontSize: 14,
                                      color: "#00a7ac",
                                    }}
                                  ></i>
                                </button>
                              </OverlayTrigger>
                            </Link>

                            {/* Dice search */}
                            <OverlayTrigger
                              placement="bottom"
                              overlay={(props) => (
                                <Tooltip id="tooltip" {...props}>
                                  Search from Dice
                                </Tooltip>
                              )}
                            >
                              <div>
                                <Link
                                  to="/Employer/DiceSearch"
                                  state={{
                                    jobDescription: jobPost.jobDescription,
                                    title: jobPost.title,
                                    location: jobPost.location,
                                    jobPostID: jobPost.jobPostID,
                                  }}
                                  style={{ textDecoration: "none" }}
                                >
                                  <button
                                    type="button"
                                    style={{
                                      backgroundColor: "#00a7ac",
                                      border: "none",
                                      color: "#fff",
                                      fontWeight: "600",
                                      fontSize: "11px",
                                      width: "18px",
                                      height: "18px",
                                      borderRadius: "3px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: "pointer",
                                      padding: 0,
                                      lineHeight: "1",
                                      marginRight: 8,
                                      transition:
                                        "background-color 0.2s ease",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.currentTarget.style.backgroundColor =
                                        "#008b8f")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.backgroundColor =
                                        "#00a7ac")
                                    }
                                  >
                                    D
                                  </button>
                                </Link>
                              </div>
                            </OverlayTrigger>

                            {/* Checkbox */}
                            {statusFilter === "Active" && (
                              <OverlayTrigger
                                placement="bottom"
                                overlay={
                                  <Tooltip id="tooltip">
                                    Select to Send Email
                                  </Tooltip>
                                }
                              >
                                <span>
                                  <input
                                    type="checkbox"
                                    checked={selectedJobPostIDs.includes(
                                      jobPost.jobPostID
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(jobPost.jobPostID)
                                    }
                                    style={{
                                      width: 16,
                                      height: 16,
                                      cursor: "pointer",
                                      marginTop: "2px",
                                      accentColor: "#00a7ac",
                                      appearance: "auto",
                                    }}
                                  />
                                </span>
                              </OverlayTrigger>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* No data */}
            {filteredJobPosts.length === 0 && (
              <div style={{ textAlign: "center" }}>
                <img
                  src={nodataimg}
                  alt="No Data"
                  style={{ width: "100%", maxWidth: "500px" }}
                />
              </div>
            )}
          </div>
        )}

        {/* Pagination */}
        {filteredJobPosts.length > itemsPerPage && (
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={Math.ceil(filteredJobPosts.length / itemsPerPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        )}

        {/* LinkedIn Modal */}
        <Modal
          show={showLinkedinModal}
          style={{ textAlign: "center" }}
          dialogClassName="custom-modal p-3"
          onHide={() => setShowLinkedinModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "#00a7ac" }}>
              Applied Filters
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="mb-3" style={{ textAlign: "left" }}>
              <label style={{ marginRight: "15px" }}>
                <input
                  type="radio"
                  name="searchType"
                  value="skills"
                  checked={searchType === "skills"}
                  onChange={() => setSearchType("skills")}
                  style={{ marginRight: "5px" }}
                />
                Search with Key Skills
              </label>

              <label>
                <input
                  type="radio"
                  name="searchType"
                  value="urls"
                  checked={searchType === "urls"}
                  onChange={() => setSearchType("urls")}
                  style={{ marginRight: "5px" }}
                />
                Search with LinkedIn URLs
              </label>
            </div>

            <label
              style={{
                color: "#00a7ac",
                display: "block",
                textAlign: "left",
                marginBottom: "0.5rem",
              }}
            >
              {searchType === "skills"
                ? "Key Skills (comma separated)"
                : "LinkedIn URLs (comma separated)"}
            </label>

            <OverlayTrigger
              placement="bottom"
              overlay={(props) => (
                <Tooltip id="tooltip" {...props}>
                  {searchType === "skills"
                    ? "Key Skills"
                    : "Enter https://linkedin.com/in/abc, https://..."}
                </Tooltip>
              )}
            >
              <textarea
                placeholder={
                  searchType === "skills"
                    ? "Key Skills"
                    : "https://linkedin.com/in/abc, https://..."
                }
                {...register("keyskills", { required: "Key Skills required" })}
                style={{ height: 250 }}
                name="keyskills"
                title=""
                value={jobDetails.keyskills ?? ""}
                onChange={(e) => {
                  let input = e.target.value;

                  if (searchType === "urls") {
                    const linkedinUrls = input.match(
                      /https?:\/\/(?:www\.)?linkedin\.com\/in\/[a-zA-Z0-9-_]+\/?/g
                    );

                    if (linkedinUrls && linkedinUrls.length > 0) {
                      input = linkedinUrls.join(", ");
                    }
                  }

                  setJobDetails({ ...jobDetails, keyskills: input });
                }}
                className={`form-control ${
                  errors.keyskills ? "is-invalid" : ""
                }`}
              />
            </OverlayTrigger>

            {errors.keyskills && (
              <p
                style={{
                  marginTop: "0.25em",
                  fontSize: "80%",
                  color: "#dc3545",
                }}
              >
                {errors.keyskills.message}
              </p>
            )}

            {searchType === "skills" && (
              <>
                <OverlayTrigger
                  placement="bottom"
                  overlay={(props) => (
                    <Tooltip id="tooltip-location" {...props}>
                      Select Location
                    </Tooltip>
                  )}
                >
                  <select
                    className="form-control basic-form mt-3"
                    defaultValue={"United States"}
                    onChange={(e) =>
                      setJobDetails({
                        ...jobDetails,
                        location: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Location</option>
                    <option value="India">India</option>
                    <option value="United States">United States</option>
                  </select>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="bottom"
                  overlay={(props) => (
                    <Tooltip id="tooltip" {...props}>
                      Experience
                    </Tooltip>
                  )}
                >
                  <input
                    placeholder="Experience"
                    type="text"
                    className="form-control basic-form mt-3"
                    value={experience || ""}
                    onChange={(e) => setexperience(e.target.value)}
                  />
                </OverlayTrigger>
              </>
            )}
          </Modal.Body>

          <Modal.Footer style={{ marginTop: 100 }}>
            <Button
              variant="primary"
              onClick={handleSubmit(() => {
                handleMatchedLinkedinCandidates({
                  jobDescription: jobDetails.jobDescription || "",
                  location: jobDetails.location || "United States",
                  experience: experience,
                  title: jobDetails.title,
                  keyskills: jobDetails.keyskills || "",
                  jobType: jobDetails.jobType,
                  jobRoleID: jobDetails.jobRoleID,
                  endClient: jobDetails.endClient,
                  jobPostID:jobDetails.jobPostID,
                });
                setShowLinkedinModal(false);
              })}
            >
              Click to Proceed
            </Button>

            <Button
              variant="secondary"
              onClick={() => setShowLinkedinModal(false)}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Matching Candidates Modal */}
        <Modal
          show={showModal}
          style={{ textAlign: "center" }}
          dialogClassName="custom-modal"
          onHide={() => setShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "#00a7ac" }}>Filters</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Select
              options={dateFilterOptions}
              placeholder="Select Date Filter"
              value={selectedDateFilter}
              onChange={(selectedOption) =>
                setSelectedDateFilter(selectedOption)
              }
              className="mt-3"
              styles={{
                control: (provided) => ({
                  ...provided,
                  height: 50,
                  borderRadius: 10,
                  fontSize: "12px",
                }),
                placeholder: (provided) => ({
                  ...provided,
                  textAlign: "left",
                  fontSize: "12px",
                }),
                singleValue: (provided) => ({
                  ...provided,
                  textAlign: "left",
                  fontSize: "12px",
                }),
              }}
            />
          </Modal.Body>

          <Modal.Footer style={{ marginTop: 100 }}>
            <Button
              variant="primary"
              onClick={() => {
                handleMatchedCandidates({
                  jobDescription: jobDetails.jobDescription,
                  jobRoleID: jobDetails.jobRoleID,
                  rolesAndResponsibilities:
                    jobDetails.rolesAndResponsibilities,
                  clientEmail: jobDetails.clientEmail,
                  jobPostID: jobDetails.jobPostID,
                  clientName: jobDetails.clientName,
                  updatedDateFilter: selectedDateFilter?.value || "",
                  jobType: jobDetails.jobType,
                  location: jobDetails.location,
                  title: jobDetails.title,
                  endClient: jobDetails.endClient,
                });
                setShowModal(false);
              }}
              disabled={!selectedDateFilter}
            >
              Click to Proceed
            </Button>

            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Mail Modal */}
        <Modal
          show={showMailModal}
          onHide={() => setShowMailModal(false)}
          dialogClassName="custom-modal"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "#00a7ac" }}>
              Select Email Options
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div
              className="form-check ml-5"
              style={{
                textAlign: "left",
                padding: "8px 0",
                position: "relative",
              }}
            >
              <input
                className="form-check-input"
                type="radio"
                name="mailType"
                value="sendJobDetails"
                checked={selectedOptions.sendJobDetails}
                onChange={handleMailRadioChange}
                id="sendJobDetails"
                style={{ marginLeft: "8px", position: "relative" }}
              />
              <label
                className="form-check-label"
                htmlFor="sendJobDetails"
                style={{ fontWeight: "normal", marginLeft: "5px" }}
              >
                Send Job Details Mail
              </label>
            </div>

            {/* RTR option commented out */}

            <div
              className="form-check ml-5"
              style={{
                textAlign: "left",
                padding: "8px 0",
                position: "relative",
              }}
            >
              <input
                className="form-check-input"
                type="radio"
                name="mailType"
                value="sendCandidateMail"
                checked={selectedOptions.sendCandidateMail}
                onChange={handleMailRadioChange}
                id="sendCandidateMail"
                style={{ marginLeft: "8px", position: "relative" }}
              />
              <label
                className="form-check-label"
                htmlFor="sendCandidateMail"
                style={{ fontWeight: "normal", marginLeft: "5px" }}
              >
                Send Mail to Candidates
              </label>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button className="btn btn-primary" onClick={handleConfirm}>
              Proceed
            </button>

            <button
              className="btn btn-primary"
              onClick={() => setShowMailModal(false)}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </ConsultantLayout>
  );
};

export default ListOfJobPosts;
